import angular from 'angular';

import {
    URL_PRIVACY_POLICY,
    URL_TERMS_OF_SERVICE,
    getPresentationStateUrl,
    getLegalStateUrl
} from 'common';

import IdentityModule from './identity';
import AuthorizedModule from './authorized';

export default angular
    .module('application.scene', [
        IdentityModule.name,
        AuthorizedModule.name
    ])
    .config(stateConfiguration);

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider
        .state('landing', {
            url: getPresentationStateUrl(),
            data: {
                external: true
            }
        })
        .state('privacy-policy', {
            url: getLegalStateUrl(URL_PRIVACY_POLICY),
            data: {
                external: {
                    blank: true
                }
            }
        })
        .state('terms-of-service', {
            url: getLegalStateUrl(URL_TERMS_OF_SERVICE),
            data: {
                external: {
                    blank: true
                }
            }
        });
}



// WEBPACK FOOTER //
// ./src/application/scene/index.js